

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_CAMPOS_RESULTADOS = "obtenerCamposResultados";
export const OBTENER_CAMPO_RESULTADOS = "obtenerCampoResultados";
export const REGISTRAR_CAMPO_RESULTADOS = "registrarCampoResultados";
export const ACTUALIZAR_CAMPO_RESULTADOS = "actualizarCampoResultados";



// mutation types
export const SET_CAMPOS_RESULTADOS = "setCamposResultados";
export const SET_CAMPO_RESULTADOS = "setCampoResultados";

const state = {
    camposResultados: [],
    campoResultados:[],
}

const getters = {
    obtenerCamposResultados(state) {
      return state.camposResultados;
    },
}

const actions = {

    /**
     * Obtener el listado de camposResultados
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_CAMPOS_RESULTADOS](context, datos) {

        /*
        * Si el estado es null va a traer a todos los departamentos, de lo contrario va a traer los departamentos por estado
        *
        */
        let endpoint = 'api/CamposResultados';
       
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_CAMPOS_RESULTADOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },   

    /**
     * Obtener un campoResultados específico
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_CAMPO_RESULTADOS](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/CamposResultados/`)
                .then(({ data }) => {
                    context.commit(SET_CAMPO_RESULTADOS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_CAMPO_RESULTADOS](context, datosCampoResultados){
        console.log(datosCampoResultados)
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/CamposResultados`, datosCampoResultados)
                .then(({ data }) => {
                    context.commit(SET_CAMPO_RESULTADOS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_CAMPO_RESULTADOS](context, datosCampoResultados){
        let id = datosCampoResultados.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/CamposResultados/`, datosCampoResultados)
                .then(({ data }) => {
                    context.commit(SET_CAMPO_RESULTADOS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },


   
    
  }

const mutations = {
    [SET_CAMPOS_RESULTADOS](state, data) {
        state.camposResultados = data;
    },

    [SET_CAMPO_RESULTADOS](state, data) {
        state.campoResultados = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}